import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineStressCortisolCortisoneCombined from "./index";

const EndocrineStressCortisolCortisoneWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineStressCortisolCortisoneCombined}
    keyControlsId="endocrine-stress-cortisol-cortisone-key"
    {...props}
  />
);

export default EndocrineStressCortisolCortisoneWithToggleKey;
